import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

/**
 * Internal link module for the Turkish blog.
 *
 * Every TR article and the blog index link with keyword-rich Turkish anchor
 * text to the three commercial landing pages, so crawlers see them as the
 * most-linked pages inside the /tr subtree.
 */
export const TR_SERVICE_LINKS = [
  {
    to: "/tr/sap-ams-destek",
    anchor: "SAP AMS destek hizmeti",
    description: "Sürekli SAP uygulama yönetimi, SLA'lı destek ve olay yönetimi.",
  },
  {
    to: "/tr/sap-uzmani-kiralama",
    anchor: "SAP uzmanı kiralama",
    description: "Tekil SAP rolleri veya komple delivery ekibi için uzman ağı.",
  },
  {
    to: "/tr/sap-s4hana-donusum",
    anchor: "SAP S/4HANA dönüşümü",
    description: "Brownfield, greenfield ve selective geçiş projeleri için ekip.",
  },
] as const;

export function TrServiceLinks({
  className = "",
  heading = "İlgili SAP hizmet sayfaları",
  exclude,
}: {
  className?: string;
  heading?: string;
  exclude?: string;
}) {
  const items = TR_SERVICE_LINKS.filter((item) => item.to !== exclude);

  return (
    <section className={`rounded-xl border border-border bg-card p-6 md:p-8 ${className}`.trim()}>
      <h2 className="text-xl font-bold md:text-2xl">{heading}</h2>
      <ul className="mt-5 grid gap-4 md:grid-cols-3">
        {items.map((item) => (
          <li key={item.to} className="rounded-lg border border-border/70 bg-background p-4">
            <Link
              to={item.to}
              className="inline-flex items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline"
            >
              {item.anchor}
              <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            <p className="mt-2 text-sm text-muted-foreground">{item.description}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
